import createVueApp from '@phoenix/createVueApp';
import { PhxMinuteRepeater, PhxMinuteRepeaterZeitwerk } from '@phx-styleguides/als';

document.querySelectorAll('.phoenix-minute-repeater').forEach((el) => {
  const app = createVueApp();
  app.component('PhxMinuteRepeater', PhxMinuteRepeater);
  app.mount(el);
});

document.querySelectorAll('.phoenix-minute-repeater-zeitwerk').forEach((el) => {
  const app = createVueApp();
  app.component('PhxMinuteRepeaterZeitwerk', PhxMinuteRepeaterZeitwerk);
  app.mount(el);
});
